import React, { useEffect } from 'react'

import { connect } from 'react-redux'

import App from '../../app'
import Auth from 'components/auth/auth'
import DoEmailAction from 'components/auth/do-email-action'
import Modal from 'components/modal/modal'

import {
	getCurrentAccount,
} from 'state/selectors'

import { Switch, Route, Redirect, withRouter } from 'react-router'

const AppContainer = ({
    currentAccount
}) => {
    useEffect(() => {
        
    }, [])

    return (
        <React.Fragment>
            <Switch>
                <Route path="/auth" component={Auth} key='1' />
                <Route path="/do-action" component={DoEmailAction} key="5" />
                <Route path="/:account_slug" component={App} key='6' />
                <Redirect from="/" to="/auth" />
            </Switch>
            <Modal 
                currentAccount={currentAccount} 
            />
        </React.Fragment>
    )
}

const mapStateToProps = state => {
	return {
		currentAccount: getCurrentAccount(state),
	}
}

export default withRouter(connect(mapStateToProps, {})(AppContainer))


// WEBPACK FOOTER //
// ./src/components/app-container/app-container.jsx